import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface WelcomeBackOrganicState {
  recommended_content_title: string | null;
  recommended_content_media_url: string | null;
}

const ruxWelcomeBackOrganic: Module<WelcomeBackOrganicState, RootState> = {
  namespaced: true,
  state: {
    recommended_content_title: null,
    recommended_content_media_url: null,
  },
  getters: {
    recommendedContentTitle: state => state.recommended_content_title,
    recommendedContentMediaUrl: state => state.recommended_content_media_url,
  },
  mutations: {
    setValue(state: WelcomeBackOrganicState, value: { is_first_course: boolean }): void {
      Object.assign(state, value);
    },
  },
};

export default ruxWelcomeBackOrganic;
